import { render, staticRenderFns } from "./ManageCertificateModal.vue?vue&type=template&id=05105454&scoped=true"
import script from "./ManageCertificateModal.vue?vue&type=script&lang=js"
export * from "./ManageCertificateModal.vue?vue&type=script&lang=js"
import style0 from "./ManageCertificateModal.vue?vue&type=style&index=0&id=05105454&prod&lang=css"
import style1 from "./ManageCertificateModal.vue?vue&type=style&index=1&id=05105454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05105454",
  null
  
)

export default component.exports